import { Injectable } from '@angular/core';
import { Query, Store, StoreConfig } from '@datorama/akita';
import produce from 'immer';
import { CsSetupSection, ElectricityMeterUnitEntry } from '../charging-stations-section.model';
import { ChargingStationsQuery } from './charging-stations.state';
import { CsSetupSectionsQuery } from './cs-setup-sections.state';


export interface EmuEntryState {
  emuEntry: ElectricityMeterUnitEntry;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'electricityMeterUnitEntryState', producerFn: produce })
export class EmuEntryStore extends Store<EmuEntryState> {
  constructor() {
    super({emuEntry: undefined});
  }
}

@Injectable({ providedIn: 'root' })
export class EmuEntryQuery extends Query<EmuEntryState> {
  private csSetupSections: CsSetupSection[];

  constructor(
    protected store: EmuEntryStore,
    private chargingStationsQuery: ChargingStationsQuery,
    private csSetupSectionsQuery: CsSetupSectionsQuery) {
      super(store);
      csSetupSectionsQuery.select().subscribe(csSetupSectionState => this.csSetupSections = csSetupSectionState.csSetupSections);
  }

  public isCurrentEmuValid(): boolean {
    return !this.isCurrentEmuInvalid();
  }

  public isCurrentEmuInvalid(excludeChargingStationId?: number, includeChargingStationId?: number): boolean {
    const chargingStationIds = this.csSetupSections.map(csSetupSection => csSetupSection.chargingStationEntry.productId);
    if (!!excludeChargingStationId) {
      const index = chargingStationIds.indexOf(excludeChargingStationId);
      if (index !== -1) {
        chargingStationIds.splice(index, 1);
      }
    }

    if (!!includeChargingStationId) {
      chargingStationIds.push(includeChargingStationId);
    }

    const possibleEmus = this.chargingStationsQuery.getPossibleElectricityMeterUnits(chargingStationIds);
    const currentEmu = this.getValue()?.emuEntry;

    return !!currentEmu && possibleEmus.every(emu => emu.id !== currentEmu.productId);
  }
}


